import { render, staticRenderFns } from "./ChargeStationInfo.vue?vue&type=template&id=2189227c&"
import script from "./ChargeStationInfo.vue?vue&type=script&lang=ts&"
export * from "./ChargeStationInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ChargeStationInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCol,VDivider})
